import {
  LanguageTestQuestion,
  LanguageTestQuestionInput
} from '../../lib/types/models/language-test/language-test-question'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateLanguageTestQuestion = ({
  sectionId,
  id,
  ...data
}: UpdateInput<LanguageTestQuestionInput> & { sectionId: number }) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.updateQuestion.url, { sectionId, id }))
    .patch<LanguageTestQuestion, Partial<LanguageTestQuestionInput>>(data)
